import React, { useEffect, useRef, useState } from "react";
import { BOOKING_ACTIONS } from "../../store/onlineBooking";
import BookingApi from "../../API/Apis/BookingApi";
import { BookingDetails } from "../../@types/Booking/bookingDetails";
import { BookingGetters } from "../../store/onlineBooking/getters";
import { StateSelectedVehicleDetails } from "../../@types/states/StateSelectedVehicleDetails";
import { TimeInMinutes } from "../../helpers/timerConfig";
import { Vehicle } from "../../@types/DTO/Vehicles.d";
import { addMinutes } from "date-fns";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ShowVehicles } from "../../components/Layouts/ShowVehicles/ShowVehicles";
import { ShowVehiclesProps } from "../../components/Layouts/ShowVehicles/ShowVehiclesProps";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { useSearchParams } from "react-router-dom";
import { BookingUrlParams } from "../../@types/Booking/linkRedirection";
import { useTranslation } from "react-i18next";
import "./Scroller.css";
import { SelectVehicleExtras } from "../../components/Layouts/VehicleExtraSelections/SelectVehicleExtra";
import { ChosenOptions } from "../../components/Layouts/BookingVehicleInfoCard/BookingVehicleInfoCard.props";
import { InsuranceDetails } from "../../@types/DTO/ApiResponses";
import { InsuranceCardsLayout } from "../../components/Layouts/Insurance/Insurance";
import theme, { formatTheme } from "../../config/MuiColorThemes";
import { SelectedVehicleExtraOptions } from "../../@types/VehicleOptions";
import createTheme from "@mui/material/styles/createTheme";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import { VehicleParameters } from "../../components/Layouts/Insurance/VehicleParameters";
import { BookingDetailsRecep } from "../../components/Layouts/BookingVehicleInfoCard/BookingDetailsRecep";
import SignIn from "../../components/Layouts/Signinform/SignIn";
import { BookingFooter } from "../../components/Layouts/BookingForm/Footer";
import PaymentPage from "../pay/PaymentPage";
import Recep from "./Recep";
import { DriverAddForm } from "../../components/Layouts/DriverAddForm/DriverAddForm";
import CollapsibleNavbar from "../../components/Layouts/ReservedAreaDashboard/CollapseNavbar";
import { AnagraphicData } from "../../components/Layouts/SignUpform/AnagraphicData";
import SignUp from "../../components/Layouts/SignUpform/SignUp";

function ChooseVehiclePage() {
  const { t: translate } = useTranslation();
  const dynamicPalette = formatTheme();
  const dynamicTheme = createTheme(dynamicPalette);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const isLoggedIn = localStorage.getItem("isUserLoggedin");
  const [allVehicles, setAllVehicles] = useState<Vehicle[]>([]);
  const [selectedVehicle, setSelectedVehicle] = useState<
    StateSelectedVehicleDetails["vehicleDetails"] | undefined
  >();
  const isDesktopScreen = window.innerWidth >= 1310;
  const pageContentStyles: React.CSSProperties = {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "2rem 1rem",
    flexGrow: 1,
  };

  const [zoomLevel, setZoomLevel] = useState(
    Math.round(window.devicePixelRatio * 100)
  );

  useEffect(() => {
    const handleResize = () =>
      setZoomLevel(Math.round(window.devicePixelRatio * 100));
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const containerMarginTop = zoomLevel <= 50 ? "calc(3% - 105px)" : "3%";
  const mainContentContainerStyles: React.CSSProperties = {
    marginLeft: isDesktopScreen ? "2%" : "undefined",
    marginTop: isDesktopScreen ? containerMarginTop : undefined,
    width: "100%",
    maxWidth: "1264px",
  };
  const [additionalDriverSelected, setAdditionalDriverSelected] =
    useState(false);
  // const updateAdditionalDriverSaved = (flag) => {
  //   setAdditionalDriverSaved(flag);
  // };
  const isPhysicalPerson: any = localStorage.getItem("isPhysicalPerson");
  // const attachedCustomer: any = localStorage.getItem("attachedCustomer");
  const isCustomerNotFound = () => {
    const customer = localStorage.getItem("attachedCustomer");
    return (
      (isLoggedIn === "true" && customer === "no customer found") ||
      customer === "null"
    );
  };

  const isCustomerValid = () => {
    const customer = localStorage.getItem("attachedCustomer");
    return (
      customer && customer !== "undefined" && customer !== "no customer found"
    );
  };

  const isPhysicalPersons = () => {
    const value = localStorage.getItem("isPhysicalPerson");
    return value == null || value !== "false";
  };

  const shouldGoToDriverStep = (currentStep) => {
    const hasNoSecondDriver = !localStorage.getItem("attachedDriver2");
    return (
      additionalDriverSelected &&
      currentStep === 3 &&
      isLoggedIn === "true" &&
      hasNoSecondDriver &&
      isCustomerValid() &&
      isPhysicalPersons()
    );
  };

  const isCompanyCustomer = () => {
    const customer = localStorage.getItem("attachedCustomer");
    return (
      isLoggedIn === "true" &&
      activeStep === 3 &&
      customer &&
      customer !== "undefined" &&
      customer !== "no customer found" &&
      isPhysicalPerson === "false"
    );
  };

  const shouldSkipCustomerStep = (currentStep) =>
    currentStep === 2 && isCustomerNotFound();

  const shouldGoToDriver = (currentStep) => shouldGoToDriverStep(currentStep);

  const shouldReturnToCustomer = (currentStep) => currentStep === 7;

  const shouldGoToCompanyStep = () => isCompanyCustomer();

  const shouldSkipStepsIfLoggedIn = (currentStep) =>
    (currentStep === 3 || currentStep === 4) && isLoggedIn === "true";

  const shouldReturnToDriver = (currentStep) =>
    currentStep === 8 || currentStep === 9;

  const shouldGoToLogin = (currentStep) =>
    currentStep === 4 && (isLoggedIn === "false" || isLoggedIn == null);

  const getStepTransitionRules = (currentStep) => [
    {
      id: "skipCustomer",
      condition: () => shouldSkipCustomerStep(currentStep),
      action: () => setActiveStep(8),
    },
    {
      id: "goToDriver",
      condition: () => shouldGoToDriver(currentStep),
      action: () => setActiveStep(7),
    },
    {
      id: "returnToCustomer",
      condition: () => shouldReturnToCustomer(currentStep),
      action: () => setActiveStep(2),
    },
    {
      id: "goToCompany",
      condition: () => shouldGoToCompanyStep(),
      action: () => setActiveStep(11),
    },
    {
      id: "skipIfLoggedIn",
      condition: () => shouldSkipStepsIfLoggedIn(currentStep),
      action: () => setActiveStep(currentStep + 2),
    },
    {
      id: "returnToDriver",
      condition: () => shouldReturnToDriver(currentStep),
      action: () => setActiveStep(3),
    },
    {
      id: "goToLogin",
      condition: () => shouldGoToLogin(currentStep),
      action: () => setActiveStep(10),
    },
  ];
  const updateActiveStep = (step) => {
    if (step) {
      setActiveStep(step);
      return;
    }
    const currentStep = activeStep;
    const rules = getStepTransitionRules(currentStep);
    for (const rule of rules) {
      if (rule.condition()) {
        rule.action();
        return;
      }
    }
    // Default action if no rules matched.
    setActiveStep(currentStep + 1);
  };

  // const updateActiveStep = (step) => {
  //   if (step) {
  //     setActiveStep(step);
  //     return;
  //   }
  //   const currentStep = activeStep;
  //   if (currentStep === 2 && isCustomerNotFound()) {
  //     setActiveStep(8);
  //   } else if (shouldGoToDriverStep(currentStep)) {
  //     console.log(localStorage.getItem("attachedCustomer"), "attchCust");
  //     setActiveStep(7);
  //   } else if (currentStep === 7) {
  //     setActiveStep(2);
  //   } else if (isCompanyCustomer()) {
  //     setActiveStep(11);
  //   } else if (
  //     (currentStep === 3 || currentStep === 4) &&
  //     isLoggedIn === "true"
  //   ) {
  //     setActiveStep(currentStep + 2);
  //   } else if (currentStep === 8 || currentStep === 9) {
  //     setActiveStep(3);
  //   } else if (
  //     currentStep === 4 &&
  //     (isLoggedIn === "false" || isLoggedIn == null)
  //   ) {
  //     setActiveStep(10);
  //   } else {
  //     setActiveStep(currentStep + 1);
  //   }
  // };

  const prevActiveStep = () => {
    const currentstep = activeStep;
    if (currentstep == 7) {
      setActiveStep(1);
    } else {
      setActiveStep(currentstep - 1);
    }
  };

  // const bookingInformation: BookingDetails = BookingGetters.getBookingDetails();
  // const [dealerSupplierId, setDealerSupplierId] = useState<string | "">(
  //   bookingInformation.pickUpLocationDetails.dealerId
  //     ? bookingInformation.pickUpLocationDetails.dealerId
  //     : ""
  // );

  const [searchParams] = useSearchParams();
  // const [discountValueWithoutVat, setDiscountValueWithoutVat] =
  //   useState<string>(
  //     reduxBookingDetails.discountValueWithoutVat
  //       ? reduxBookingDetails.discountValueWithoutVat
  //       : "0"
  //   );
  const [canProceed, setCanProceed] = useState({ value: false });
  const [privacySelected, setPrivacySelected] = useState(false);
  const [termsCondnSelected, setTermsCondnSelected] = useState(false);
  const isPrivacyPolicyChecked = (selectedValue) => {
    setPrivacySelected(selectedValue.length > 0);
  };
  const dealerId = searchParams.get("dealerId") || "";
  const isTermsCondnChecked = (selectedValue) => {
    setTermsCondnSelected(selectedValue.length > 0);
  };

  useEffect(() => {
    setCanProceed({ value: privacySelected && termsCondnSelected });
  }, [privacySelected, termsCondnSelected]);
  const navigation = useNavigate();
  const [activeStep, setActiveStep] = React.useState(0);
  const updateActiveSteps = (step) => {
    setActiveStep(step);
  };

  const ReservationDetails = BookingGetters.getBookingDetails();
  const [hasShownInsuranceTab, setHasShownInsuaranceTab] =
    useState<boolean>(false);
  const [activeTab] = useState<string>("0");
  const [insuranceList, setInsuranceList] = useState<InsuranceDetails>({
    "Booking Insurance": [],
    Specification: [],
  });
  const [selectedFields, setSelectedFields] = useState<ChosenOptions>({
    options: {},
    insurance: insuranceList["Booking Insurance"].find(
      (e) => parseFloat(e.Amount.toString()) === 0
    )
      ? {
          details:
            insuranceList["Booking Insurance"].find(
              (e) => parseFloat(e.Amount.toString()) === 0
            )?.Description || "",
          insuranceId:
            insuranceList["Booking Insurance"]
              .find((e) => parseFloat(e.Amount.toString()) === 0)
              ?.Id.toString() || "",
          price: 0,
        }
      : undefined,
  });
  // const [selectedFields, setSelectedFields] = useState<ChosenOptions>({
  //   options: {},
  //   insurance: undefined,
  // });
  const discount = (100 - (selectedVehicle?.Vehicle?.payNowDis || 0)) / 100;
  const [totalPrice, setTotalPrice] = useState<number>(
    parseFloat(
      selectedVehicle?.TotalCharge?.RateTotalAmount.toString() || "0"
    ) * discount
  );
  const [showInfo, setShowInfo] = useState(false);
  const toogleVehicleInfoCardShowingStatus = () => {
    setShowInfo(!showInfo);
  };
  const [userId] = useState(localStorage.getItem("userID"));
  const appSettings = BookingGetters.getAppSettings();
  const [extrasPrice, setExtrasPrice] = useState(0); // extras and insurance price
  const [onlyExtrasPrice, setOnlyExtrasPrice] = useState<number>(0); // extras price
  const [insurancePrice, setInsurancePrice] = useState<number>(0); // insurance price
  const [vehiclePrice, setVehiclePrice] = useState<number>(0); // insurance price
  // ----------- Filters  -------------------
  const [tempAvailabilityFilter] = useState<
    ShowVehiclesProps["vehiclesFilter"]
  >({
    Transmission: {},
    status: {},
    category: {},
    type: {},
    TotalSeats: [],
    MacroGroup: {},
  });
  const [filterValue, setFilterValue] = useState<
    ShowVehiclesProps["vehiclesFilter"]
  >({
    Transmission: {},
    status: {},
    category: {},
    type: {},
    TotalSeats: [],
    MacroGroup: {},
  });
  const textResource = BookingGetters.getTextResource()?.data ?? [];
  useEffect(() => {
    const timer = setTimeout(() => {
      setFilterValue(tempAvailabilityFilter);
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [tempAvailabilityFilter]);
  const divRef = useRef<HTMLDivElement | null>(null);
  const [offsetFromTop, setOffsetFromTop] = useState(0);
  useEffect(() => {
    const calculateOffset = () => {
      if (divRef.current) {
        const rect = divRef.current.getBoundingClientRect();
        setOffsetFromTop(rect.top); // Directly use rect.top, which updates as you scroll
      }
    };
    calculateOffset(); // Calculate once when activeStep changes
    // Add scroll event listener to update the offset during scroll
    const handleScroll = () => {
      calculateOffset();
    };
    window.addEventListener("scroll", handleScroll); // Listen to scroll events
    // Cleanup the event listener on unmount or when activeStep changes
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [activeStep]);
  useEffect(() => {
    BookingApi.getAllPaymentMethods(dealerId).then((e) => {
      delete e.wireTransfer;
      dispatch(BOOKING_ACTIONS.setPaymentMethods(e));
    });
  }, []);

  useEffect(() => {
    document.body.style.overflowX = "hidden";

    return () => {
      document.body.style.overflowX = "";
    };
  }, []);

  // --------------- END FILTER --------------------------
  useEffect(() => {
    setHasShownInsuaranceTab(hasShownInsuranceTab || activeTab == "1");
  }, [activeTab]);
  const [hasError, setHasError] = useState(false);
  useEffect(() => {
    if (userId && userId !== "null" && userId !== "") {
      BookingApi.createNewOnlineUserAndCustomer(dealerId)
        .then((res) => {
          console.log(res);
        })
        .catch(() => {
          setHasError(true);
        });
    }
  }, [userId, dealerId]);
  useEffect(() => {
    if (
      userId &&
      userId != "null" &&
      userId != "" &&
      selectedVehicle?.Vehicle
    ) {
      const saveToLocalStorage = (key, value, defaultValue = "") => {
        localStorage.setItem(key, value ?? defaultValue);
      };
      BookingApi.getAttachCust(dealerId)
        .then((response) => {
          saveToLocalStorage(
            "attachedCustomer",
            response?.attachCustomer,
            "null"
          );
          saveToLocalStorage(
            "isPhysicalPerson",
            response?.isPhysicalPerson?.toString()
          );
          saveToLocalStorage(
            "isBlocklistCustomer",
            response?.isBlocklistCustomer?.toString(),
            "false"
          );
          saveToLocalStorage(
            "onlineUserStatus",
            response?.onlineUserStatus?.toString(),
            "null"
          );
        })
        .catch(() => {
          setHasError(true);
        });
    }
  }, [userId, selectedVehicle?.Vehicle]);

  useEffect(() => {
    if (selectedVehicle?.Vehicle) {
      dispatch(
        BOOKING_ACTIONS.setSelectedVehicleDetails({
          paymentDetails: {
            addedExtraOptions: selectedFields?.options,
            isDiscounted: selectedVehicle?.Vehicle?.payNowDis || 0,
            price: totalPrice,
            selectedInsurance: selectedFields?.insurance,
            type: "PAYNOW",
            isPayLaterFee: false,
            payLaterFeeAmt: "",
            extrasPrice: extrasPrice,
            extrasIncluded: true,
          },
          vehicleDetails: selectedVehicle,
        })
      );
      setTimeout(() => {}, 200);
    }
  }, [selectedVehicle, selectedFields, totalPrice]);

  useEffect(() => {
    let price: number = parseFloat(
      selectedFields.insurance?.price?.toString() || "0"
    );
    setInsurancePrice(price);
    let selectedExtras: number = parseFloat("0");
    if (selectedFields.options) {
      Object.values<SelectedVehicleExtraOptions>(selectedFields.options).map(
        (el) => {
          price += el.price * el.quantity;
          selectedExtras += el.price * el.quantity;
        }
      );
    }
    setExtrasPrice(price);
    const totalPrice =
      parseFloat(
        selectedVehicle?.TotalCharge?.RateTotalAmount.toString() || "0"
      ) * discount;
    const totalPriceAfterExtra = price + totalPrice;
    setOnlyExtrasPrice(selectedExtras);
    setVehiclePrice(totalPrice);
    setTotalPrice(totalPriceAfterExtra);
  }, [selectedFields, selectedVehicle?.TotalCharge?.RateTotalAmount]);

  useEffect(() => {
    setIsLoading(true);
    setHasError(false);
    const t: BookingUrlParams = {
      dropOffDateAndTime: searchParams.get("dropOffDateAndTime") || "",
      pickUpDateAndTime: searchParams.get("pickUpDateAndTime") || "",
      pickUpLocation: searchParams.get("pickUpLocation") || "",
      dropOffLocation: searchParams.get("dropOffLocation") || "",
      pickUpLocationName: searchParams.get("pickUpLocationName") || "",
      dropOffLocationName: searchParams.get("dropOffLocationName") || "",
      reservationSource: searchParams.get("reservationSource") || "WEB001",
      showPics: searchParams.get("showPics") || "true",
      showOptionalImage: searchParams.get("showOptionalImage") || "true",
      showVehicleParameter: searchParams.get("showVehicleParameter") || "true",
      showBookingDiscount: searchParams.get("showBookingDiscount") || "true",
      showVehicleExtraImage:
        searchParams.get("showVehicleExtraImage") || "true",
    };
    for (const i in t) {
      if (!t[i]) {
        navigation("/");
      }
    }
    const currentBookingDetails: BookingDetails = {
      pickUpDateAndTime: new Date(parseInt(t.pickUpDateAndTime)).getTime(),
      dropOffDateAndTime: new Date(parseInt(t.dropOffDateAndTime)).getTime(),
      dropOffLocationDetails: {
        name: "",
        code: t.dropOffLocation,

        dealerId: "",
        dealerName: "",
        locationDescription: t.pickUpLocationName,
        email: "",
        latitude: "",
        longitude: "",
        locationWithDealerName: "",
        showLoggedInDealerLoc: "",
      },
      pickUpLocationDetails: {
        name: "",
        code: t.pickUpLocation,
        dealerId: "",
        dealerName: "",
        locationDescription: t.pickUpLocationName,
        email: "",
        latitude: "",
        longitude: "",
        locationWithDealerName: "",
        showLoggedInDealerLoc: "",
      },
      pickUpLocationName: t.pickUpLocationName || "",
      dropOffLocationName: t.dropOffLocationName || "",
      reservationSource: t.reservationSource || "",
      // macroGroupName: t.macroGroupName || "",
      showPics: t.showPics == "true",
      showOptionalImage: t.showOptionalImage == "true",
      showVehicleParameter: t.showVehicleParameter == "true",
      showVehicleExtraImage: t.showVehicleExtraImage == "true",
      showBookingDiscount: t.showBookingDiscount == "true",
      isPayLaterFee: false,
      payLaterFeeAmt: "",
    };

    function transformLocationData(data: any): any[] {
      const locationResponse: any[] = [];

      if (data?.data?.data === "") return locationResponse;

      Object.keys(data.data).forEach((dealerId) => {
        const dealerData = data.data[dealerId];
        const locations = Object.keys(dealerData)
          .filter(
            (key) => key !== "dealerName" && key !== "dealerReservationSource"
          )
          .map((locationName) => ({
            ...dealerData[locationName],
            locationName,
            dealerId,
            dealerName: dealerData.dealerName,
            dealerReservationSource: dealerData.dealerReservationSource,
            showLoggedInDealerLoc: dealerData.showLoggedInDealerLoc,
          }));
        locationResponse.push(...locations);
      });

      return locationResponse.sort((a, b) =>
        a.locationName.localeCompare(b.locationName)
      );
    }

    function findLocations(locations, pickUpCode, dropOffCode) {
      const pickUpLocation = locations.find((loc) => loc.code === pickUpCode);
      const dropOffLocation = locations.find((loc) => loc.code === dropOffCode);
      return { pickUpLocation, dropOffLocation };
    }

    function getLocationDetails(location, fallbackLocation = {}) {
      return {
        name: location.locationName || fallbackLocation.locationName,
        code: location.code || fallbackLocation.code,
        dealerId: location.dealerId,
        dealerName: location.dealerName,
        locationDescription: location.description,
        email: location.email,
        latitude: location.latitude,
        longitude: location.longitude,
        locationWithDealerName: location.locationName,
        showLoggedInDealerLoc: location.showLoggedInDealerLoc,
      };
    }

    function populateBookingDetails(
      pickUpLocation,
      dropOffLocation,
      bookingDetails
    ) {
      bookingDetails.pickUpLocationDetails = getLocationDetails(
        pickUpLocation,
        dropOffLocation
      );
      bookingDetails.dropOffLocationDetails =
        getLocationDetails(dropOffLocation);
    }

    function clearLocalStorage() {
      if (localStorage.getItem("isPhysicalPerson") === "false") {
        localStorage.removeItem("attachedDriver");
      }
      [
        "additionalDriver2",
        "additionalDriver3",
        "additionalDriver4",
        "additionalDriver5",
      ].forEach((key) => localStorage.removeItem(key));
    }

    // const idSupplier: any = localStorage.getItem("idSupplier");
    BookingApi.getReservationLocations()
      .then((data) => {
        const locationResponse = transformLocationData(data);
        const { pickUpLocation, dropOffLocation } = findLocations(
          locationResponse,
          t.pickUpLocation,
          t.dropOffLocation
        );

        if (!pickUpLocation || !dropOffLocation) {
          navigation("/");
          return Promise.reject(new Error("Invalid location"));
        }

        populateBookingDetails(
          pickUpLocation,
          dropOffLocation,
          currentBookingDetails
        );
        currentBookingDetails.reservationSource =
          t.reservationSource || "WEB001";

        dispatch(
          BOOKING_ACTIONS.setBookingInformation({ ...currentBookingDetails })
        );

        return BookingApi.getReservationVehicles(
          currentBookingDetails,
          dealerId
        );
      })
      .then((vehiclesResponse) => {
        dispatch(
          BOOKING_ACTIONS.setSessionExpiryTime(
            addMinutes(new Date(), TimeInMinutes).getTime()
          )
        );
        clearLocalStorage();
        setAllVehicles([...(vehiclesResponse.data?.data?.Vehicles || [])]);
      })
      .catch(() => {
        setHasError(true);
      })
      .finally(() => {
        setActiveStep(searchParams.get("callSignIn") === "callSignIn" ? 4 : 0);
        setIsLoading(false);
      });
  }, []);

  const istabletScreen = window.innerWidth >= 768 && window.innerWidth <= 1220;
  const isSmallScreen = window.innerWidth <= 768;
  function getParentOrigin() {
    try {
      if (
        window.location.ancestorOrigins &&
        window.location.ancestorOrigins.length > 0
      ) {
        return window.location.ancestorOrigins[0];
      }
      if (document.referrer) {
        return new URL(document.referrer).origin;
      }
    } catch (error) {
      return "";
    }
  }
  const parentOrigin = getParentOrigin();
  const allowedOrigins = new Set([
    "https://mbrent.mercedes-benz.it",
    "https://bookingmerfina.mbrent.mercedes-benz.it",
    "https://mbrent.mercedes-benz.it/congaratulation",
    "https://merfinatestbooking.myrent.it",
    "https://mauroc147.myrent.it",
  ]);
  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";
  function requestParentResize() {
    let iframeHeight = document.body.scrollHeight + 100;
    if (activeStep == 3) {
      iframeHeight = resDetailsDivHeight + 513 + 160; //513 recep and 180px extra space
    } else if (activeStep == 5) {
      iframeHeight = paymentPageHeight + recepDivHeight + 160; //513 recep and 180px extra space
    }
    window.parent.postMessage(
      {
        event_id: "iframeHeight",
        data: {
          iframeHeight: iframeHeight,
        },
      },
      targetOrigin
    );
  }
  const scrollToTop = () => {
    window.parent.postMessage(
      {
        event_id: "scrollToTop",
      },
      targetOrigin
    );
  };
  useEffect(() => {
    if (activeStep === 5 && paymentPageRef.current) {
      const paymentPageRefHeight = paymentPageRef.current.offsetHeight;
      setPaymentPageHeight(paymentPageRefHeight);
    }
  }, [activeStep]);
  useEffect(() => {
    if (activeStep == 1 || activeStep == 3) {
      requestParentResize();
    }
    if (
      activeStep == 2 ||
      activeStep == 1 ||
      activeStep == 11 ||
      activeStep == 7 ||
      activeStep == 9
    ) {
      scrollToTop();
      window.scrollTo(0, 0);
    }
  }, [activeStep]);
  const [paymentPageHeight, setPaymentPageHeight] = useState<number>(0);
  useEffect(() => {
    if (activeStep === 5 && paymentPageHeight > 0) {
      requestParentResize();
    }
  }, [paymentPageHeight, activeStep]);
  const [findInsuranceBody, setFindInsuranceBody] = useState({});
  const findTextForInsuranceBody = (feature, vehicleName) => {
    if (!findInsuranceBody[feature + ":" + vehicleName]) {
      const textVal = textResource.find(
        (item) =>
          item.key === "insurance:" + feature.toUpperCase() + ":" + vehicleName
      );
      setFindInsuranceBody((prevData) => ({
        ...prevData,
        [feature + ":" + vehicleName]: textVal ? textVal?.body : "",
      }));
    }
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const toggleDrawer = (isOpen) => {
    setIsDrawerOpen(isOpen);
  };
  // useEffect(() => {
  //   const handleMessage = (event) => {
  //     console.log("event listen" + event.data);
  //     if (event.data === "openCollapseNavbar") {
  //       toggleDrawer();
  //     }
  //   };
  //
  //   window.addEventListener("message", handleMessage);
  //
  //   return () => {
  //     window.removeEventListener("message", handleMessage);
  //   };
  // });
  //******************* iframeHeight dynamic for desktop************ */
  const recepRef = useRef(null);
  const extrasPageRef = useRef(null);
  // const bookingFooterRef = useRef(null);
  const insurancePageRef = useRef(null);
  const resDetailPageRef = useRef(null);
  const paymentPageRef = useRef(null);

  const [recepDivHeight, SetRecepDivHeight] = useState<number>(0);
  const [extrasPageDivHeight, SetExtrasPageDivHeight] = useState<number>(0);
  const [insurancePageDivHeight, SetInsurancePageDivHeight] =
    useState<number>(0);
  const [resDetailsDivHeight, SetResDetailsDivHeight] = useState<number>(0);
  // const [bookingFooterDivHeight, SetBookingFooterDivHeight] =
  //   useState<number>(0);

  const [totalHeightRecepExtrasFooter, setTotalHeightRecepExtrasFooter] =
    useState<number>(recepDivHeight + extrasPageDivHeight + 180);
  const [totalHeightRecepInsuranceFooter, setTotalHeightRecepInsuranceFooter] =
    useState<number>(recepDivHeight + insurancePageDivHeight + 180);
  const [totalResDetailsHeight, setTotalResDetailsHeight] = useState<number>(
    recepDivHeight + resDetailsDivHeight + 160
  );

  useEffect(() => {
    if (recepRef.current) {
      const recepHeight = recepRef.current.offsetHeight;
      SetRecepDivHeight(recepHeight);
    }
    if (extrasPageRef.current) {
      const extraPageHeight = extrasPageRef.current.offsetHeight;
      SetExtrasPageDivHeight(extraPageHeight);
    }
    // if (bookingFooterRef.current) {
    //   const footerPageHeight = bookingFooterRef.current.offsetHeight;
    //   SetBookingFooterDivHeight(footerPageHeight);
    // }
    if (insurancePageRef.current) {
      const insPageHeight = insurancePageRef.current.offsetHeight;
      SetInsurancePageDivHeight(insPageHeight);
    }
    if (resDetailPageRef.current) {
      const resPageHeight = resDetailPageRef.current.offsetHeight;
      SetResDetailsDivHeight(resPageHeight);
    }
    // if (divRef.current) {
    //   const divHeight = divRef.current.offsetHeight;
    // }
  });

  useEffect(() => {
    setTotalHeightRecepExtrasFooter(
      extrasPageDivHeight + recepDivHeight + 180 + 10
    );
    setTotalHeightRecepInsuranceFooter(
      insurancePageDivHeight + recepDivHeight + 180 + 10
    );
    setTotalResDetailsHeight(resDetailsDivHeight + recepDivHeight + 160 + 10);
  }, [
    recepDivHeight,
    extrasPageDivHeight,
    // bookingFooterDivHeight,
    insurancePageDivHeight,
    resDetailsDivHeight,
  ]);
  //******************* iframeHeight dynamic for desktop************ */
  useEffect(() => {
    dispatch(
      BOOKING_ACTIONS.setSelectedFields({
        selectedFields: { selectedFields },
      })
    );
  }, [selectedFields]);
  useEffect(() => {
    const totalPricesForRedux = {
      onlyExtrasPrice: onlyExtrasPrice,
      insurancePrice: insurancePrice,
      totalPrice: totalPrice,
      vehiclePrice: vehiclePrice,
    };
    dispatch(
      BOOKING_ACTIONS.setPrices({
        setPrices: totalPricesForRedux,
      })
    );
  }, [onlyExtrasPrice, insurancePrice, totalPrice, vehiclePrice]);

  return (
    <ThemeProvider theme={dynamicTheme || theme}>
      <>
        <div
          style={{
            color: "white",
            marginTop: "-8px",
          }}
        >
          <CollapsibleNavbar
            isDrawerOpen={isDrawerOpen}
            toggleDrawer={toggleDrawer}
          />
        </div>
      </>
      <div>
        {userId != null && userId !== "null" && userId !== "" && !isSmallScreen}
      </div>
      <div className="flex flex-col box-border">
        <div ref={recepRef}>
          <Recep
            offsetFromTop={offsetFromTop}
            divRef={divRef}
            activeStep={activeStep}
            istabletScreen={istabletScreen}
            isSmallScreen={isSmallScreen}
            selectedVehicle={selectedVehicle}
            updateActiveSteps={updateActiveSteps}
            selectedFields={selectedFields}
            textResource={textResource}
            vehiclePrice={vehiclePrice}
            insurancePrice={insurancePrice}
            onlyExtrasPrice={onlyExtrasPrice}
            totalPrice={totalPrice}
            isDesktopScreen={isDesktopScreen}
            isPaymentPage={false}
          />
        </div>
        {activeStep == 0 && (
          <div>
            {userId != null && userId !== "null" && userId !== ""}
            <main>
              {!isLoading ? (
                <ShowVehicles
                  onVehicleSelect={async (e: StateSelectedVehicleDetails) => {
                    setIsLoading(true);
                    const insuranceDetails =
                      await BookingApi.getInsuranceDetails(
                        ReservationDetails,
                        e.vehicleDetails.Vehicle?.Code || "",
                        e.vehicleDetails.optionals || [],
                        dealerId
                      );
                    setInsuranceList(insuranceDetails);
                    if (insuranceDetails["Booking Insurance"]) {
                      insuranceDetails["Booking Insurance"].forEach((item) => {
                        findTextForInsuranceBody(
                          item.Description,
                          e.vehicleDetails.Vehicle?.Code
                        );
                      });
                    }
                    setActiveStep(1);
                    setSelectedVehicle(e.vehicleDetails);
                    setIsLoading(false);
                  }}
                  allVehicles={allVehicles}
                  vehiclesFilter={filterValue}
                  className={`animate__animated animate__slideInUp ${
                    !isSmallScreen ? "ml-[4px] mr-[25px]" : ""
                  } ${userId != null && userId !== "null" && userId !== ""}`}
                  textColor={
                    dynamicTheme?.palette["secondaryColor"]?.contrastText
                  }
                  backgroundColor={
                    dynamicTheme?.palette["backgroundColor"]?.main
                  }
                  backgroundTextColor={
                    dynamicTheme?.palette["secondaryColor"]?.main
                  }
                  locationName={searchParams.get("pickUpLocationName") || ""}
                  latitude={parseFloat(searchParams.get("latitude") || "0")}
                  longitude={parseFloat(searchParams.get("longitude") || "0")}
                  hasError={hasError}
                />
              ) : (
                <div
                  className={
                    "flex flex-col justify-center items-center w-full mt-20"
                  }
                >
                  <CircularProgress />
                </div>
              )}
            </main>
          </div>
        )}
        <section className="hover:drop-shadow-lg cursor-pointer rounded-tl-[32px] rounded-br-[12px] rounded-bl-[12px] relative flex flex-col bg-white  box-border font-roboto  text-[#004188] z-12">
          {showInfo && (
            <div className="hover:drop-shadow-lg cursor-pointer rounded-tl-[32px] rounded-br-[12px] rounded-bl-[12px] h-full w-full absolute bg-white p-4 z-10 top-0 left-0 animate__animated animate__zoomIn">
              <div>
                <Button
                  className="w-1/3 flex justify-end"
                  onClick={() => {
                    toogleVehicleInfoCardShowingStatus();
                  }}
                >
                  close
                </Button>
                <p>This is the info that should be displayed on the card.</p>
              </div>
            </div>
          )}
        </section>
        {activeStep == 1 && (
          <>
            <div style={pageContentStyles} ref={extrasPageRef}>
              <div style={mainContentContainerStyles}>
                <div
                  className={`h-full w-full animate__animated animate__slideInUp`}
                  style={{
                    WebkitOverflowScrolling: "touch",
                    touchAction: "pan-y",
                  }}
                >
                  {(istabletScreen || isDesktopScreen) && (
                    <div
                      className={isSmallScreen ? "mt-4" : "mt-8"}
                      style={{ paddingLeft: "7px" }}
                    >
                      <VehicleParameters
                        activeStep={activeStep}
                        specifications={
                          selectedVehicle?.Vehicle?.vehicleParameter
                        }
                      />
                    </div>
                  )}
                  <div
                    className={isSmallScreen ? "mt-4" : "mt-8"}
                    style={{ marginTop: "7%" }}
                  >
                    {" "}
                    <SelectVehicleExtras
                      values={selectedFields.options || {}}
                      totalHeightRecepExtrasFooter={
                        totalHeightRecepExtrasFooter
                      }
                      onChange={(e: any) => {
                        if (Array.isArray(e)) {
                          const driverExtras = e.filter(
                            (el) => el.name === "DRIVER"
                          );
                          if (driverExtras != null && driverExtras.length > 0)
                            setAdditionalDriverSelected(true);
                        } else if (
                          typeof e === "object" &&
                          e !== null &&
                          e.DRIVER
                        ) {
                          setAdditionalDriverSelected(true);
                        } else {
                          setAdditionalDriverSelected(false);
                        }
                        setSelectedFields((prev) => ({
                          ...prev,
                          options: e,
                        }));
                      }}
                      insuranceList={insuranceList}
                      options={
                        selectedVehicle?.optionals?.map((e) => ({
                          ...e,
                          iconUrl: e.Equipment.optionalImage || "#",
                          maxAllowed: e.Equipment.maxQuantity,
                          optionName: e.Equipment?.EquipType || "",
                          pricePerDayInUSD: (e.Charge.Amount || 0).toString(),
                          details: e.Equipment?.Description || "",
                          applyRateOptionalBooking:
                            e.Equipment?.applyRateOptionalBooking,
                        })) || []
                      }
                      cardBackgroundColor={
                        appSettings?.fillColorToCard
                          ? dynamicTheme?.palette["backgroundColor"]?.main
                          : dynamicTheme?.palette["secondaryColor"]?.main
                      }
                      selectedCardBackgroundColor={
                        dynamicTheme?.palette["primary"]?.main
                      }
                      cardTextColor={
                        appSettings?.fillColorToCard
                          ? dynamicTheme?.palette["backgroundColor"]
                              ?.contrastText
                          : dynamicTheme?.palette["secondaryColor"]
                              ?.contrastText
                      }
                      selectedCardTextColor={
                        dynamicTheme?.palette["primary"]?.contrastText
                      }
                      secondaryColor={
                        dynamicTheme?.palette["secondaryColor"]?.main
                      }
                      fillToCard={appSettings?.fillColorToCard}
                    />
                  </div>
                </div>
              </div>
            </div>

            <BookingFooter
              updateActiveStep={updateActiveStep}
              prevActiveStep={prevActiveStep}
              canProceed={{ value: true }}
              activeStep={activeStep}
              locationName={searchParams.get("pickUpLocationName") || ""}
              totalPrice={totalPrice}
              isSmallScreen={isSmallScreen}
              istabletScreen={istabletScreen}
              isDesktopScreen={isDesktopScreen}
            />
          </>
        )}
        {activeStep === 7 && (
          <>
            <div style={{ marginBottom: "2%" }}>
              <DriverAddForm
                heading={translate("Additional Driver Data")}
                dealerId={dealerId}
              />
            </div>
            {/* <div>
              s
                updateActiveStep={updateActiveStep}
                prevActiveStep={prevActiveStep}
                canProceed={{ value: additionalDriverSaved }}
                activeStep={activeStep}
                locationName={searchParams.get("pickUpLocationName") || ""}
                totalPrice={totalPrice}
                isSmallScreen={isSmallScreen}
                istabletScreen={istabletScreen}
                isDesktopScreen={isDesktopScreen}
              />
            </div> */}
          </>
        )}
        {activeStep === 2 && (
          <>
            <div style={pageContentStyles} ref={insurancePageRef}>
              <div style={mainContentContainerStyles}>
                <div
                  style={{
                    marginLeft: isDesktopScreen ? "2%" : "undefined",
                    marginTop: isDesktopScreen ? "3%" : "undefined",
                  }}
                  className={`h-full w-full animate__animated animate__slideInUp`}
                >
                  {istabletScreen ||
                    (isDesktopScreen && (
                      <VehicleParameters
                        specifications={
                          selectedVehicle?.Vehicle?.vehicleParameter
                        }
                      />
                    ))}
                  <div
                    style={
                      isDesktopScreen
                        ? {
                            marginTop: "7%",
                          }
                        : {}
                    }
                    className={isSmallScreen ? "" : ""}
                  >
                    <InsuranceCardsLayout
                      totalHeightRecepInsuranceFooter={
                        totalHeightRecepInsuranceFooter
                      }
                      selectedInsuranceIndex={insuranceList[
                        "Booking Insurance"
                      ].findIndex(
                        (e) =>
                          e.Description.toLowerCase() ===
                          selectedFields.insurance?.details.toLowerCase()
                      )}
                      onSelected={(index) => {
                        setSelectedFields((prev) => {
                          if (index < 0) {
                            const newFields = { ...prev };
                            delete newFields.insurance;
                            return newFields;
                          } else {
                            return {
                              ...prev,
                              insurance: {
                                details:
                                  insuranceList["Booking Insurance"][index]
                                    .Description,
                                insuranceId:
                                  insuranceList["Booking Insurance"][
                                    index
                                  ].Id.toString(),
                                price: parseFloat(
                                  insuranceList["Booking Insurance"][
                                    index
                                  ].Amount.toString()
                                ),
                              },
                            };
                          }
                        });
                      }}
                      insurances={
                        insuranceList["Booking Insurance"]?.map((e) => {
                          return {
                            name: e.Description,
                            pricePerDayInUSD: e.Amount.toString(),
                            features: e.Specification,
                            isRecommended: e.isRecommended,
                            bookingText: e.bookingText,
                          };
                        }) || []
                      }
                      secondaryColor={
                        dynamicTheme?.palette["secondaryColor"]?.main
                      }
                      cardBackgroundColor={
                        dynamicTheme?.palette["backgroundColor"]?.main
                      }
                      selectedCardBackgroundColor={
                        dynamicTheme?.palette["ternaryColor"]?.main
                      }
                      cardTextColor={
                        dynamicTheme?.palette["backgroundColor"]?.contrastText
                      }
                      selectedCardTextColor={
                        dynamicTheme?.palette["ternaryColor"]?.contrastText
                      }
                      fillToCard={appSettings?.fillColorToCard}
                      vehicleGroup={selectedVehicle?.Vehicle?.Code}
                      insuranceBody={findInsuranceBody}
                    />
                  </div>
                </div>
              </div>
            </div>
            <BookingFooter
              updateActiveStep={updateActiveStep}
              prevActiveStep={prevActiveStep}
              canProceed={{ value: true }}
              activeStep={activeStep}
              locationName={searchParams.get("pickUpLocationName") || ""}
              totalPrice={totalPrice}
              isSmallScreen={isSmallScreen}
              istabletScreen={istabletScreen}
              isDesktopScreen={isDesktopScreen}
            />
          </>
        )}

        {activeStep === 8 && (
          <>
            <div style={{ marginBottom: "2%" }}>
              <AnagraphicData
                updateActiveSteps={updateActiveSteps}
                dealerId={dealerId}
                returnToRecep="true"
              />
            </div>
            {/*<div>*/}
            {/*  <BookingFooter*/}
            {/*    updateActiveStep={updateActiveStep}*/}
            {/*    prevActiveStep={prevActiveStep}*/}
            {/*    activeStep={activeStep}*/}
            {/*    locationName={searchParams.get("pickUpLocationName") || ""}*/}
            {/*    totalPrice={totalPrice}*/}
            {/*    isSmallScreen={isSmallScreen}*/}
            {/*    istabletScreen={istabletScreen}*/}
            {/*    isDesktopScreen={isDesktopScreen}*/}
            {/*    canProceed={canProceed}*/}
            {/*  />*/}
            {/*</div>*/}
          </>
        )}
        {activeStep === 11 && (
          <>
            <div style={{ marginBottom: "2%" }}>
              <DriverAddForm
                heading={translate("Additional Driver Data")}
                dealerId={dealerId}
                openDriverAfterCompanyDriver={additionalDriverSelected}
              />
            </div>
            {/* {additionalDriverSelected && (
              <BookingFooter
                updateActiveStep={updateActiveStep}
                prevActiveStep={prevActiveStep}
                canProceed={canProceed}
                activeStep={activeStep}
                locationName={searchParams.get("pickUpLocationName") || ""}
                totalPrice={totalPrice}
                isSmallScreen={isSmallScreen}
                istabletScreen={istabletScreen}
                isDesktopScreen={isDesktopScreen}
              />
            )} */}
          </>
        )}

        {activeStep === 9 && (
          <>
            <div style={{ marginBottom: "2%" }}>
              <DriverAddForm
                heading={translate("Additional Driver Data")}
                dealerId={dealerId}
              />
            </div>
            {/* <BookingFooter
              updateActiveStep={updateActiveStep}
              prevActiveStep={prevActiveStep}
              canProceed={canProceed}
              activeStep={activeStep}
              locationName={searchParams.get("pickUpLocationName") || ""}
              totalPrice={totalPrice}
              isSmallScreen={isSmallScreen}
              istabletScreen={istabletScreen}
              isDesktopScreen={isDesktopScreen}
            /> */}
          </>
        )}
        {activeStep === 3 && (
          <>
            <div style={pageContentStyles} ref={resDetailPageRef}>
              <div style={mainContentContainerStyles}>
                <div
                  className={`h-full w-full animate__animated animate__slideInUp ${
                    isSmallScreen ? "mt-[10%] bg-white shadow-lg" : ""
                  }`}
                  style={{ marginTop: "2%" }}
                >
                  {!isSmallScreen && (
                    <VehicleParameters
                      specifications={
                        selectedVehicle?.Vehicle?.vehicleParameter
                      }
                      activeStep={undefined}
                    />
                  )}
                  <div
                    style={
                      !isSmallScreen
                        ? {
                            marginTop: "64px",
                          }
                        : {}
                    }
                  >
                    <BookingDetailsRecep
                      totalResDetailsHeight={totalResDetailsHeight}
                      paymentPage={"false"}
                      allPaymentMethods={[]}
                      selectedFields={selectedFields}
                      updatePaymentMethod={""}
                      selectedPaymentMethod={""}
                      isPrivacyPolicyChecked={isPrivacyPolicyChecked}
                      isTermsCondnChecked={isTermsCondnChecked}
                      activeStep={activeStep}
                    />
                  </div>
                </div>
              </div>
            </div>
            <BookingFooter
              updateActiveStep={updateActiveStep}
              prevActiveStep={prevActiveStep}
              canProceed={canProceed}
              activeStep={activeStep}
              totalPrice={totalPrice}
              isSmallScreen={isSmallScreen}
              istabletScreen={istabletScreen}
              isDesktopScreen={isDesktopScreen}
            />
          </>
        )}
        {(isLoggedIn == "false" || isLoggedIn == null) && activeStep === 4 && (
          <SignIn openPayment={true} callFrom={"booking"} />
        )}

        {isLoggedIn == "true" && (activeStep === 5 || activeStep === 6) && (
          <PaymentPage
            offsetFromTop={offsetFromTop}
            divRef={divRef}
            isSmallScreen={isSmallScreen}
          />
        )}

        {/* Add the SignUpForm component */}
        {activeStep === 10 && <SignUp />}
      </div>
    </ThemeProvider>
  );
}

export { ChooseVehiclePage };
